import {Component, Prop, Vue, Emit, Watch} from 'vue-property-decorator';
import service from "../../assets/service/service";

/**
 *
 */

@Component
export default class SelectData extends Vue {
    @Prop({default: () => 'loading'}) private status!: any;     // loading状态
    @Prop({default: () => ''}) private errorMsg!: any;          // 错误信息
    @Prop({default: () => ''}) private width!: any;          // 错误信息

    @Watch('status', {immediate: true})
    private watchStatus(value: any) {}

    @Watch('errorMsg', {immediate: true})
    private watchErrorMsg(value: any) {
    }
}
